import React, { useEffect, useReducer, useRef } from 'react';
import { setAuthHeader } from './axiosHeader';
import { useDispatch } from 'react-redux'
import { setAuth } from '../redux/authSlice'

export const AuthContext = React.createContext();

export default function AuthProvider({ userManager: manager, store, children }) {
    let userManager = useRef();
    const dispatch = useDispatch();

    useEffect(() => {
        userManager.current = manager

        const onUserLoaded = (user) => {
            store.dispatch(dispatch(setAuth({user: user})));
        }

        const onUserUnloaded = () => {
            setAuthHeader(null);
        }

        const onAccessTokenExpiring = async () => {
        }

        const onAccessTokenExpired = async () => {
        }

        const onUserSignedOut = () => {
        }

        // events for user
        userManager.current.events.addUserLoaded(onUserLoaded);
        userManager.current.events.addUserUnloaded(onUserUnloaded);
        userManager.current.events.addAccessTokenExpiring(onAccessTokenExpiring);
        userManager.current.events.addAccessTokenExpired(onAccessTokenExpired);
        userManager.current.events.addUserSignedOut(onUserSignedOut);

        // Specify how to clean up after this effect:
        return function cleanup() {
            userManager.current.events.removeUserLoaded(onUserLoaded);
            userManager.current.events.removeUserUnloaded(onUserUnloaded);
            userManager.current.events.removeAccessTokenExpiring(onAccessTokenExpiring);
            userManager.current.events.removeAccessTokenExpired(onAccessTokenExpired);
            userManager.current.events.removeUserSignedOut(onUserSignedOut);
        };
    }, [manager, store]);

    return (
        <AuthContext.Provider value={manager}>
            {React.Children.only(children)}
        </AuthContext.Provider>
    )
}